import { render, staticRenderFns } from "./CustomerFormModal.vue?vue&type=template&id=0e6feaf2"
import script from "./CustomerFormModal.vue?vue&type=script&lang=js"
export * from "./CustomerFormModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports